type SpinnerProps = {
  size?: "small" | "medium" | "large";
  absolute?: boolean | "parent";
};

export function Spinner(props: SpinnerProps = {}) {
  const spinner = (
    <div className="app-spinner">
      <div className="app-spinner__bg"></div>
      <div className="app-spinner__logo"></div>
    </div>
  );

  if (!props.absolute) {
    return spinner;
  }

  const backdropClassName =
    props.absolute === "parent"
      ? "app-spinner-backdrop app-spinner-backdrop--parent"
      : "app-spinner-backdrop";

  return <div className={backdropClassName}>{spinner}</div>;
}
